import React from 'react';
import { Mail, Phone, MapPin, Facebook, Instagram } from 'lucide-react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-black text-white py-16 px-4 sm:px-6 lg:px-8">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 mb-12">
          {/* Contact Column */}
          <div>
            <h4 className="text-lg font-semibold mb-4">Contact Us</h4>
            <div className="space-y-3">
              <div className="flex items-start">
                <MapPin className="mr-3 mt-1 flex-shrink-0" size={18} />
                <span className="text-gray-300">
                  1709 Taylors Island Rd<br />
                  Woolford, MD 21677
                </span>
              </div>
              <div className="flex items-center">
                <Phone className="mr-3 flex-shrink-0" size={18} />
                <a href="tel:+14435150072" className="text-gray-300 hover:text-white transition-colors duration-200">
                  (443) 515-0072
                </a>
              </div>
              <div className="flex items-center">
                <Mail className="mr-3 flex-shrink-0" size={18} />
                <a href="mailto:agreenerside1990@gmail.com" className="text-gray-300 hover:text-white transition-colors duration-200">
                  agreenerside1990@gmail.com
                </a>
              </div>
            </div>
          </div>

          {/* Hours & Social Column */}
          <div>
            <h4 className="text-lg font-semibold mb-4">Visit Hours</h4>
            <p className="text-gray-300 mb-4">
              Monday - Saturday: 9:00 AM - 6:00 PM<br />
              Sunday: Closed<br />
              <span className="text-sm italic">Schedule an appointment for Sunday visits</span>
            </p>
            <div className="flex space-x-4 mt-6">
              <a 
                href="https://www.facebook.com/share/16xiedJEJn/" 
                target="_blank"
                rel="noopener noreferrer"
                className="bg-gray-800 p-3 rounded-full hover:bg-gray-700 transition-colors duration-200"
                aria-label="Facebook"
              >
                <Facebook size={20} />
              </a>
              <a 
                href="https://www.instagram.com/Agreenersidenursery"
                target="_blank"
                rel="noopener noreferrer"
                className="bg-gray-800 p-3 rounded-full hover:bg-gray-700 transition-colors duration-200"
                aria-label="Instagram"
              >
                <Instagram size={20} />
              </a>
            </div>
          </div>
        </div>

        <div className="border-t border-gray-800 pt-8 text-center text-gray-400">
          <p>&copy; {currentYear} AGreenerSide Ecotourism Farm. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
